<template>
  <div class="flex h-screen items-center justify-center bg-primary">
    <div
      class="h-10 w-10 animate-spin rounded-full border-4 border-accent border-t-transparent shadow-sm"
    />
  </div>
</template>

<script setup lang="ts"></script>
